import PropTypes from "prop-types"
import Tooltip from "components/material/tooltip"
import { OfflineBolt } from "@mui/icons-material"

export default function AdjustmentIndicator({ periodAdjusted, selectedDateAdjusted }) {
  if (!periodAdjusted && !selectedDateAdjusted) {
    return null
  }

  const getTooltipMessage = () => {
    if (!periodAdjusted && selectedDateAdjusted) {
      return "The selected date has been adjusted to reflect data availability"
    }
    return "The dates have been adjusted to reflect data availability"
  }

  return (
    <Tooltip title={getTooltipMessage()}>
      <OfflineBolt className="warning" />
    </Tooltip>
  )
}

AdjustmentIndicator.propTypes = {
  periodAdjusted: PropTypes.bool,
  selectedDateAdjusted: PropTypes.bool,
}
